module.exports = "https://cdn.littlereply.com/tt/resource/bonus_coins.6aa32b94c752862a27cd57b9565f64eb.png";